import { Box, Card, Input, Slider, TextField, Typography } from "@mui/material";
import { getColor } from "../style/color/color";
import deleteIcon from "../assets/icon/Group_33961.png";
import { fonts } from "../style/fonts/fonts";

export const DependantQuestionCard = ({
  question,
  placeholder,
  totalAge,
  depandantName,
  isVisible,
  onRemoveClick,
  onDependantNameChange,
  onDepandantAgeChange,
}) => {
  return (
    <Box
      sx={{
        mt: 5,
      }}
    >
      <Card
        sx={{
          p: 3,
          borderRadius: 8,
          boxShadow: "0px 4px 12px rgba(80, 86, 98, 0.15)",
        }}
      >
        {isVisible && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              cursor: "pointer",
            }}
            // component={"button"}
            onClick={onRemoveClick}
          >
            <img src={deleteIcon} alt="delete Icon" />
          </Box>
        )}
        <TextField
          slotProps={{
            input: {
              disableUnderline: true,
              sx: {
                textAlign: "center",
                fontWeight: "600",
              },
            },
          }}
          value={depandantName || ""}
          variant="standard"
          sx={{
            width: "100%",
            maxWidth: "300px",
            borderRadius: 3,
            border: "0.50px #505662 solid",
            textAlign: "center",
            p: "10px",
            mt: "20px",

            "& input": {
              textAlign: "center",
              fontWeight: "700",
            },
          }}
          placeholder={placeholder}
          onChange={(e) => {
            const newValue = e.target.value.trim() === "" ? "" : e.target.value;

            onDependantNameChange(newValue);
          }}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Typography
            sx={{
              mt: "25px",
              ml: "12px",
              color: getColor.NeutralDark700,
              fontSize: 15,
              fontFamily: fonts.manrope,
              fontWeight: 500,
            }}
          >
            {question}
          </Typography>
          <Input
            sx={{
              borderRadius: 2,
              border: "1px solid black",
              p: 1,
              mt: "15px",
              mr: "12px",
              width: "70px",
              color: getColor.NeutralDark700,
              fontSize: 16,
              fontFamily: fonts.manrope,
              fontWeight: 700,
              wordWrap: "break-word",
              textAlign: "center",
              "& input": {
                textAlign: "center",
                fontWeight: "700",
              },
            }}
            disableUnderline={true}
            value={totalAge}
            onChange={(e) => {
              onDepandantAgeChange(e.target.value);
            }}
            inputProps={{
              type: "number",
              fontWeight: "600",
            }}
          ></Input>
        </Box>
        <Slider
          aria-labelledby="input-slider"
          valueLabelDisplay="auto"
          value={Number(totalAge) || 0}
          onChange={(e, newValue) => {
            onDepandantAgeChange(newValue);
          }}
          min={1}
          max={100}
          step={1}
          sx={{
            width: "90%",
            ml: "12px",
            mr: "12px",
            p: 1,
            color: getColor.ExtendedpalettesSummerSkySS800,
            "& .MuiSlider-thumb": {
              height: 24,
              width: 24,
              backgroundColor: getColor.PrimaryWhite,
              border: "1px solid currentColor",
              "&:hover": {
                boxShadow: "inherit",
              },
            },
            "& .MuiSlider-track": {
              height: 8,
              borderRadius: 4,
            },
            "& .MuiSlider-rail": {
              height: 8,
              borderRadius: 4,
              backgroundColor: "rgba(0, 0, 0, 0.10)",
            },
          }}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            ml: "12px",
            mr: "12px",
          }}
        >
          <Typography
            sx={{
              fontSize: 14,
              color: getColor.Grey,
            }}
          >
            {`${1} yr`}
          </Typography>

          <Typography
            sx={{
              fontSize: 14,
              color: getColor.Grey,
            }}
          >
            {`${100} yrs`}
          </Typography>
        </Box>
      </Card>
    </Box>
  );
};
